import { MediaItemCarousel } from '../../../../../../components/redesign/media-carousel/models/media-item-carousel.model';
import { MappedCertificate } from '../../../models/mapped-certificate.model';
import { getYoutubeMedia } from '../../youtube/youtube.helper';

export function getMediaCarouselItemFromCertificate(
	certificate: MappedCertificate,
): MediaItemCarousel[] {
	let mediaList = [];
	if (certificate && certificate.medias) {
		let previewUrl = '';
		let ytMedia: { ytId: string; thumbnail: string; embedURL: string } = null;
		mediaList = certificate.medias
			.filter((media) => media.url)
			.filter(
				(media) =>
					![
						'itemBackgroundPicture',
						'certificateBackgroundPicture',
						'brandItemBackgroundPicture',
					].includes(media.type),
			)
			.map((media, index, certificateMedias) => {
				switch (media.mediaType) {
					case 'youtube':
						ytMedia = getYoutubeMedia(media);
						return {
							type: media.mediaType,
							url: ytMedia.embedURL,
							preview: ytMedia.thumbnail,
							order: media.order,
						};
					case 'picture':
						previewUrl = media.preview;
						return media.type === 'product'
							? {
									type: media.mediaType,
									url: media.url,
									preview: previewUrl,
									order: media.order,
							  }
							: undefined;

					case 'video':
						return media.type === 'videoPreview'
							? {
									type: media.mediaType,
									preview: certificateMedias[index].url,
									url: certificateMedias[index + 1]
										? certificateMedias[index + 1].url
										: undefined,
									order: media.order,
							  }
							: undefined;
					case 'AR':
						if (media.type === 'ARPrimaryAsset') {
							return {
								type: 'ARPrimaryAsset',
								url: media.url,
								order: media.order,
							};
						}
						return media.type === 'ARPreview'
							? {
									type: media.mediaType,
									preview: certificateMedias[index].url,
									url: certificateMedias[index + 1]
										? certificateMedias[index + 1].url
										: undefined,
									order: media.order,
							  }
							: undefined;
					case '3dModel':
						return media.type === '3dModelPreview'
							? {
									type: media.mediaType,
									preview: certificateMedias[index].url,
									url: certificateMedias[index + 1]
										? certificateMedias[index + 1].url
										: undefined,
									order: media.order,
							  }
							: undefined;
					default:
						console.warn('Invalid media type:', media.type);
						return null;
				}
			})
			.filter((media) => media);

		mediaList = [...mediaList];
	}

	return mediaList;
}
